import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

import Header from "./components/Header";
import Home from "./components/home-page/Home";
import About from './components/about-us/About';
import Contact from './components/contact-us/Contact';
import Heritage from './components/package/Heritage';
import Activity from './components/package/Activity';
import Blog from './components/explore/Blog';
import ConversionMain from './components/package/ConservationMain';
import Education from './components/explore/Education';
import Upcoming from './components/upcomig/Upcoming';
import Team from './components/team/Team';
import LandingPage from './components/landing-page/LandingPage';
import LandingPage2 from './components/landing-page/LandingPage2';
import LandingPage3 from './components/landing-page/LandingPage3';
import Demo3 from './components/landing-page/Demo3';
function App() {
  const location = useLocation(); 
  const hideHeaderPaths = ['/', '/2', '/3']; // Paths where the header should not appear

  return (
    <>
      <div className="background-wrapper">
        <div className="content-wrapper">
          {!hideHeaderPaths.includes(location.pathname) && <Header />}
          
          <main>
            <Routes>
              {/* Landing Page Routes */}
              <Route path="/" exact element={<LandingPage />} />
              <Route path="/2" exact element={<LandingPage3 />} />
              <Route path="/3" exact element={<Demo3 />} />

              {/* Other Routes */}
              <Route path="/home" element={<Home />} />
              <Route path="/about-us" element={<About />} />
              <Route path="/contact-us" element={<Contact />} />
              <Route path="/heritage" element={<Heritage />} />
              <Route path="/activities" element={<Activity />} />
              <Route path="/conservation" element={<ConversionMain />} />
              <Route path="/explore/education-awareness" element={<Education />} />
              <Route path="/explore/blogs" element={<Blog />} />
              <Route path="/upcoming" element={<Upcoming />} />
              <Route path="/team" element={<Team />} />
            </Routes>
          </main>
        </div>
      </div>
    </>
  );
}

export default App;
